module.exports = __webpack_public_path__ + "img/didYouHear.1fc93774.png";